import { Link } from "react-router-dom";
import useSEO from "@/hooks/useSEO";

export default function NotFound() {
  useSEO({ title: "Page not found | Juwai Teer", description: "The page you requested could not be found.", canonical: "https://jowaiteer.com/", noindex: true });
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-16 pb-10 text-center">
      <div className="font-display font-extrabold text-6xl text-[color:var(--brand-purple-deep)]">404</div>
      <div className="mt-2 text-lg text-[color:var(--brand-purple)]">Page not found</div>
      <p className="mt-4 text-sm text-[color:var(--brand-purple)]/85">The page you requested doesn&apos;t exist.</p>
      <Link to="/" className="btn-purple mt-6 inline-flex" data-testid="404-home-btn">Back to Home</Link>
    </div>
  );
}
